import { Link } from 'react-router-dom';
import Header2 from '@/components/Header2';
import Footer from '@/components/Footer';

const NotFoundPage = () => {
  return (
    <div className="min-h-screen flex flex-col">
      <Header2 />
      
      <main className="flex-1 flex items-center justify-center px-4 py-8 bg-gray-50">
        <div className="max-w-4xl w-full grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center">
          <div className="text-center md:text-left">
            <h1 className="text-6xl md:text-8xl font-black text-red-500 leading-none mb-4">
              404
            </h1>
            <h2 className="text-2xl md:text-3xl font-semibold text-gray-800 mb-4">
              Pagina nu a fost găsită
            </h2>
            <p className="text-lg text-gray-600 mb-8 leading-relaxed">
              Ne pare rău, dar pagina pe care o căutați nu există sau a fost mutată.
            </p>
            
            <div className="flex flex-col sm:flex-row gap-4 justify-center md:justify-start mb-8">
              <Link 
                to="/" 
                className="px-6 py-3 bg-blue-600 text-white rounded-md font-medium hover:bg-blue-700 transition-colors duration-300 text-center"
              >
                Înapoi la Pagina Principală
              </Link>
              <button 
                className="px-6 py-3 bg-gray-600 text-white rounded-md font-medium hover:bg-gray-700 transition-colors duration-300"
                onClick={() => window.history.back()}
              >
                Înapoi la Pagina Anterioară
              </button>
            </div>
            
         
          </div>
          
          <div className="flex justify-center items-center">
            <svg 
              width="200" 
              height="200" 
              viewBox="0 0 200 200" 
              fill="none" 
              xmlns="http://www.w3.org/2000/svg"
              className="opacity-70"
            >
              <circle cx="100" cy="100" r="80" stroke="#e0e0e0" strokeWidth="4" fill="none"/>
              <path d="M70 80 L130 80" stroke="#666" strokeWidth="4" strokeLinecap="round"/>
              <path d="M70 120 Q100 140 130 120" stroke="#666" strokeWidth="4" strokeLinecap="round" fill="none"/>
            </svg>
          </div>
        </div>
      </main>
      
      <Footer />
    </div>
  );
};

export default NotFoundPage;